import * as Sentry from "@sentry/react";

declare const __APP_RELEASE__: string;

// Sentry DSNs are public by design — safe to commit. They identify the project, not authenticate.
const DSN = "https://536ca4a5285ca0e64962f4ece1d189f5@o4511233188691968.ingest.us.sentry.io/4511233191772160";

const hostname =
  typeof window !== "undefined" ? window.location.hostname : "";

const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
const isLovablePreview =
  hostname.includes("id-preview--") || hostname.endsWith("lovableproject.com");
const isLovableStaging = hostname.endsWith("lovable.app");
const isProduction =
  hostname === "elarahealth.life" || hostname.endsWith(".elarahealth.life");

function resolveEnvironment(): string {
  if (isLocalhost) return "development";
  if (isLovablePreview) return "preview";
  if (isLovableStaging) return "staging";
  if (isProduction) return "production";
  return import.meta.env.MODE || "unknown";
}

// Disable Sentry on localhost + Lovable iframe preview to avoid dev noise.
export const sentryEnabled = !!DSN && !isLocalhost && !isLovablePreview;

export function initSentry() {
  if (!sentryEnabled) return;
  Sentry.init({
    dsn: DSN,
    environment: resolveEnvironment(),
    release: __APP_RELEASE__,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
  });
}

export { Sentry };
